
import React from 'react'
import Packet from './Packet';
import { fs } from '../controls/Constants';
import Button from './Button';

const Introduction = () => {
    
    return (
        <div className="color">
        <div>
            <h1 className='text-center'>Welcome to Kari</h1>
            <p className={fs}>
            Whether you're a seasoned developer with years of experience or a beginner just 
            starting your journey with Arduino, Kari is here to make your IoT and embedded systems development faster,
            easier, and more enjoyable.
            This library is designed to streamline your workflow and simplify complex tasks, enabling
            you to focus on the creative aspects of your projects. Kari is a powerful toolkit, 
            offering a variety of features that cater to hobbyists and professionals alike. From managing sequential operations 
            and asynchronous tasks to integrating sensors with minimal setup, Kari's design philosophy centers around efficiency,
            reliability, and ease of use. By providing intuitive abstractions and reusable components, 
            Kari helps you bring your ideas to life faster and with fewer obstacles.
            </p>
            <p className={fs}>
            Kari was developed and published by <span className='highlight-color'>Vincent Muriithi Karimi</span>, a software engineer with a strong background in IoT, embedded systems and electrical and electronics engineering. 
            Passionate about innovation, Vincent created Kari to simplify asynchronous programming and sensor integration for Arduino projects.
            </p>
        </div>

        <section className={fs}>
            <h2 className='text-center'>What Makes Kari Stand Out?</h2>
            <article className='packet-container'>
                <Packet
                title="Robust and Versatile Features"
                data={
                    `Kari empowers you to handle common IoT and Arduino tasks with ease, 
                including pin control, pulse toggling, and sensor measurement. 
                Its comprehensive set of tools is designed to be adaptable to a wide range of applications.
                    `}
                />
                <Packet
                title="Efficient Sequential Processing"
                data={
                    `Manage complex workflows effortlessly with tools like kariSequential and kariAsync. 
                    Whether you're toggling LEDs in a sequence or scheduling tasks at precise intervals, Kari has you covered
                    `
                }
                />
                <Packet
                title="Seamless Sensor Integration"
                data={
                    `Simplify the process of working with sensors like ultrasonic range finders, 
                    motion detectors, and infrared sensors. Built-in classes like kariUltrasonic, kariPIR, 
                    and kariInfrared abstract away the complexities, allowing you to focus on your project’s logic.
                    `
                }
                />
                <Packet
                title="Intuitive and User-Friendly"
                data={
                    `Designed with both simplicity and power in mind, 
                    Kari’s API ensures a smooth learning curve while providing advanced capabilities for experienced developers.
                    `
                }
                />
            </article>
        </section>

        <main className='packet-container'>
            <section className={`${fs} green`}>
                <h2 className='text-center'>How Kari Simplifies Your Projects</h2>
                <article className='packet-row'>
                    <Packet
                    title="Improves Workflow"
                    data={
                        `By offering reusable and modular components,
                        Kari reduces the amount of repetitive code and helps maintain cleaner project structures.
                        `
                    }
                    />
                    <Packet
                    title="Enhances Reliability"
                    data={
                        `Built-in features such as efficient resource management and 
                        task scheduling ensure that your project runs smoothly and consistently.
                        `
                    }
                    />
                    <Packet
                    title="Encourages Scalability"
                    data={
                        `Kari is built to support projects of all sizes, 
                            from small prototypes to large-scale systems.
                        `
                    }
                    />
                </article>
            </section>
        

            <section className={`${fs} green`}>
                <h2 className='text-center'>Perfect for All Skill Levels</h2>
                <article className='packet-row'>
                    <Packet
                    title="For Beginners"
                    data={
                        `Kari provides a gentle introduction to the world of Arduino and IoT, 
                    making it easy to get started without overwhelming complexity.
                        `
                    }
                    />
                    <Packet
                    title="For Professionals"
                    data={
                        `Advanced features and robust functionality allow experienced developers to 
                        tackle ambitious projects with confidence.
                        `
                    }
                    />
                    <Packet
                    title="For Educators"
                    data={
                        `Kari is an excellent teaching tool, helping students learn foundational concepts 
                        in IoT development through hands-on practice.
                        `
                    }
                    />
                </article>
            </section>
        </main>
        <section className={fs}>
            <h2>What’s Inside?</h2>
            <p>In this documentation, you’ll find everything you need to unlock the full potential of the Kari Library,
                 including:</p>
            <p><strong>Comprehensive API References</strong>: Detailed explanations of all classes, methods, and features.</p>
            <p><strong>Code Examples</strong>: Explore real-world use cases and ready-to-run snippets that demonstrate Kari’s capabilities.</p>
        </section>

        <section className={fs}>
            <h2 className='text-center'>Get Started Today</h2>
            <p>
            Whether you’re building a simple IoT prototype or a complex automation system, Kari is here to empower your creativity. 
            With its robust feature set and developer-focused design, Kari simplifies the hardest parts of your development process, so you can focus on making your ideas a reality.
            <br/>
            Explore the documentation to learn more about how Kari can transform your Arduino projects. 
            Let’s build something amazing together!
            </p>
            <div className='flex-center'>
            <Button
            text="Explore Documentation"
            override="btn-override"
            route="/documentation"
            />
            </div>
        </section>
        </div>
    )
}

export default Introduction
